import React from 'react';
import { Edit, DeleteOutline } from '@mui/icons-material';
import { getMoneyMask, toAmericanDate, toBrazilianDate } from '../../helpers';
import TableHeader from '../../models/TableHeader';
import CheckboxField from '../../components/UI/Field/Checkbox/CheckboxField';
import TooltipUI from '../../components/UI/Tooltip/Tooltip';
import { blackTwo } from '../../helpers/constants/colors.constants';
import { TableActionButton, TableActionContainer } from '../../components/UI/Tabela/tableDefaultStyles';

class NotasFiscaisDevedorFactory {
  makeCabecalhoTabela(
    changeSelectAll = () => { },
    selectAll = false,
  ) {
    return [
      new TableHeader({
        id: 'idProcessoNF',
        checkbox: true,
        label: (
          <CheckboxField
            checked={selectAll}
            onChange={changeSelectAll}
          />
        ),
        alignCell: 'left',
        maxWidth: 39,
      }),
      new TableHeader({
        id: 'idProcesso',
        label: 'Processo',
        alignCell: 'center',
        maxWidth: '10%',
      }),
      new TableHeader({
        id: 'cnpj',
        label: 'CNPJ',
        alignCell: 'center',
        maxWidth: '10%',
      }),
      new TableHeader({
        id: 'razaoSocial',
        label: 'Razão Social',
        alignCell: 'center',
        maxWidth: '12%',
      }),
      new TableHeader({
        id: 'email',
        label: 'E-mail',
        alignCell: 'center',
        maxWidth: '12%',
      }),
      new TableHeader({
        id: 'cidade',
        label: 'Cidade',
        alignCell: 'center',
        maxWidth: '10%',
      }),
      new TableHeader({
        id: 'estado',
        label: 'Estado',
        alignCell: 'center',
        maxWidth: '6%',
      }),
      new TableHeader({
        id: 'valorPrincipal',
        label: 'Valor Principal',
        alignCell: 'right',
        maxWidth: '10%',
      }),
      new TableHeader({
        id: 'valorPago',
        label: 'Valor Pago',
        alignCell: 'right',
        maxWidth: '10%',
      }),
      new TableHeader({
        id: 'honorariosAmigaveis',
        label: 'Honorários Amigáveis',
        alignCell: 'right',
        maxWidth: '12%',
      }),
      new TableHeader({
        id: 'dataEmissao',
        label: 'Data Emissão',
        alignCell: 'center',
        maxWidth: '10%',
      }),
      new TableHeader({
        id: 'acoes',
        label: 'Ações',
        alignCell: 'center',
        maxWidth: '8%',
      }),
    ];
  }

  makeConteudoTabela(
    notasFiscaisDevedor,
    changeSelectId,
    listIds,
    goToEditarNotaFiscal,
    goToExcluirNotaFiscal,
    dadosResumo,
  ) {
    if (!notasFiscaisDevedor || notasFiscaisDevedor.length === 0) {
      return [];
    }

    return notasFiscaisDevedor.map(notaFiscal => ({
      id: notaFiscal.idProcesso,
      values: {
        idProcessoNF: (
          <CheckboxField
            name={String(notaFiscal.idProcesso)}
            checked={listIds[notaFiscal.idProcesso] || false}
            onChange={changeSelectId}
          />
        ),
        idProcesso: notaFiscal.idProcesso,
        cnpj: notaFiscal.cnpj || '-',
        razaoSocial: notaFiscal.razaoSocial || '-',
        email: notaFiscal.email || '-',
        cidade: notaFiscal.cidade || '-',
        estado: notaFiscal.estado || '-',
        valorPrincipal: getMoneyMask(notaFiscal.valorPrincipal),
        valorPago: getMoneyMask(notaFiscal.valorPago),
        honorariosAmigaveis: getMoneyMask(notaFiscal.honorariosAmigaveis),
        dataEmissao: dadosResumo.find(item => item.idProcesso === notaFiscal.idProcesso)?.dataEmissao || toBrazilianDate(new Date()),
        acoes: (
          <div>
            <TableActionContainer>
              <TooltipUI title="Editar Data de Emissão" placement="bottom">
                <TableActionButton
                  onClick={() => {
                    goToEditarNotaFiscal(notaFiscal.idProcesso, toBrazilianDate(new Date()));
                  }}
                >
                  <Edit size={20} color={blackTwo} />
                </TableActionButton>
              </TooltipUI>
              <TooltipUI title="Excluir Processo" placement="bottom">
                <TableActionButton
                  onClick={() => {
                    goToExcluirNotaFiscal(notaFiscal.idProcesso);
                  }}
                >
                  <DeleteOutline size={20} color={blackTwo} />
                </TableActionButton>
              </TooltipUI>
            </TableActionContainer>
          </div>
        ),
      },
    }));
  }

  buildPayloadGerarNotaFiscalDevedor(conteudoSelecionado) {
    return conteudoSelecionado.map(item => ({
      idProcesso: item.idProcesso,
      honorariosAmigaveis: item.honorariosAmigaveis,
      dataEmissao: toAmericanDate(item.dataEmissao),
    }));
  }

  buildPayloadFormFields(formFields, idsProcessosExcluidos = []) {
    return {
      periodoInicial: toAmericanDate(formFields.periodoInicial.value),
      periodoFinal: toAmericanDate(formFields.periodoFinal.value),
      valorInicial: formFields.valorInicial.value,
      valorFinal: formFields.valorFinal.value,
      cpfCnpj: formFields.cpfCnpj.value === '' ? null : formFields.cpfCnpj.value,
      numeroProcesso: formFields.numeroProcesso.value,
      razaoSocial: formFields.razaoSocial.value === '' ? null : formFields.razaoSocial.value,
      idsProcessosExcluidos,
    };
  }

  buildPayloadNotaFiscalDevedor(formFields, dadosResumo, idsProcessosExcluidos) {
    return {
      infoNotaFiscalDevedorCommand: this.buildPayloadFormFields(formFields, idsProcessosExcluidos),
      resumoNotaFiscalDevedorCommandList: dadosResumo.map(item => ({
        idProcesso: item.idProcesso,
        dataEmissao: toAmericanDate(item.dataEmissao),
      })),
    };
  }
}

export const notasFiscaisDevedorFactory = new NotasFiscaisDevedorFactory();
